<template>
    <div class="edit-one-element" id="edit-one-element__component">
         <transition 
            name="fade-delete-button" 
            appear
            mode="out-in"
        >
            <div class="edit-one-element__delete" 
                v-if="buttonDelete"
                @click="clickDelete()"
                >
                <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5H3M3 5H19M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5H3ZM6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M8 10V16M12 10V16" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="edit-one-element__delete-text">
                    Удалить
                </div>
            </div>
        </transition >
        <div class="edit-one-element__replacement"
            @click="clickReplacement()"
        >
            <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23 1.99763V7.99763M23 7.99763H17M23 7.99763L18.36 3.63763C17.2853 2.56235 15.9556 1.77684 14.4952 1.35441C13.0348 0.931975 11.4911 0.886385 10.0083 1.22189C8.52547 1.5574 7.1518 2.26307 6.01547 3.27305C4.87913 4.28304 4.01717 5.56442 3.51 6.99763M1 17.9976V11.9976M1 11.9976H7M1 11.9976L5.64 16.3576C6.71475 17.4329 8.04437 18.2184 9.50481 18.6409C10.9652 19.0633 12.5089 19.1089 13.9917 18.7734C15.4745 18.4379 16.8482 17.7322 17.9845 16.7222C19.1209 15.7122 19.9828 14.4308 20.49 12.9976" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="edit-one-element__delete-text">
                Заменить
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'buttonDelete',
            'buttonReplacement',
            'info'
        ],
        methods: {
            async clickDelete() {
                this.$emit('clickDelete', this.info)
            },
            async clickReplacement() {
                this.$emit('clickReplacement', this.info)
            }
        }
    }
</script>

<style lang="less">
    .edit-one-element {
        height: 66px;
        margin-top: 10px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .edit-one-element__delete,
    .edit-one-element__replacement {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 40px;
        justify-content: space-between;
        cursor: pointer;
    }

    .edit-one-element__delete {
        overflow: hidden;
        width: auto;
        margin-right: 50px;
        opacity: 1;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .edit-one-element__delete-text {
        font-size: 10px;
        line-height: 18px;
        font-weight: 300;
        text-align: center;
        color: #FFFFFF;
        font-family: 'Roboto-Light';
    }

    .fade-delete-button-enter-active {
        animation: fade-delete-button .2s ease forwards;
    }
        

    .fade-delete-button-leave-active {
        animation: fade-delete-button .2s ease reverse forwards;
    }

    @keyframes fade-delete-button {
        0% {
            width: 0px;
            margin-right: 0px;
            opacity: 0;
        }

        100% {
            opacity: 1;
            width: 30px;
            margin-right: 50px;
        }

    }
</style>